var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.648475 1.95692C0.475473 1.78392 0.378281 1.54927 0.378281 1.30461C0.378281 1.05995 0.475473 0.825308 0.648475 0.652306C0.821478 0.479304 1.05612 0.382112 1.30078 0.382112C1.54544 0.382112 1.78008 0.479304 1.95309 0.652306L19.3479 18.0471C19.5209 18.2201 19.6181 18.4548 19.6181 18.6994C19.6181 18.9441 19.5209 19.1787 19.3479 19.3517C19.1749 19.5247 18.9403 19.6219 18.6956 19.6219C18.4509 19.6219 18.2163 19.5247 18.0433 19.3517L0.648475 1.95692Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0411 0.652306C18.2141 0.479304 18.4487 0.382112 18.6934 0.382112C18.938 0.382112 19.1727 0.479304 19.3457 0.652306C19.5187 0.825308 19.6159 1.05995 19.6159 1.30461C19.6159 1.54927 19.5187 1.78392 19.3457 1.95692L1.95084 19.3517C1.77784 19.5247 1.54319 19.6219 1.29853 19.6219C1.05387 19.6219 0.819229 19.5247 0.646227 19.3517C0.473225 19.1787 0.376032 18.9441 0.376032 18.6994C0.376032 18.4548 0.473226 18.2201 0.646228 18.0471L18.0411 0.652306Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/Close_ICON.9a3b0827d352128a790c6385bf43271e.svg";
export { ForwardRef as ReactComponent };